import { Button, Flex, Group, Stack, Table, Text } from '@mantine/core';
import { IconArrowNarrowRight } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CenterReport } from '@/module/Laboratory/CenterReport';
import { LabInfoChangeButton } from '@/module/Laboratory/info/LabInfoChangeButton';
import { LabInfraList } from '@/module/Laboratory/infra/LabInfraList';

import { EditButtonLink } from '@/core/components';

import { LaboratoryDeleteButton } from './components/LaboratoryDeleteButton';
import { Laboratory } from './model/LaboratoryTypes';

interface LaboratoryViewProps {
  laboratory: Laboratory;
}

export function LaboratoryView(props: LaboratoryViewProps) {
  const { laboratory } = props;
  const { name, researchTeam, domain } = laboratory;
  const [isGathering, setIsGathering] = useState(false);
  const { t } = useTranslation();

  return (
    <Stack>
      <Flex justify="space-between">
        <Text fw="500">{name}</Text>
        <Group>
          <LabInfoChangeButton
            labInfo={{ domain: domain ?? '', researchTeam: researchTeam ?? '' }}
            labId={laboratory.id}
          />
          <EditButtonLink
            size="xs"
            miw="100px"
          />
          <LaboratoryDeleteButton laboratory={laboratory.id} />
        </Group>
      </Flex>
      {!isGathering && (
        <Button
          bg="#652ef9"
          leftSection={<IconArrowNarrowRight />}
          onClick={() => setIsGathering(true)}
        >
          Raportează activitatea laboratorului
        </Button>
      )}

      {!isGathering && (
        <Stack>
          <Table
            variant="vertical"
            withTableBorder
            style={{ borderRadius: '12px' }}
          >
            <Table.Tbody>
              <Table.Tr>
                <Table.Th w={280}>{t('labs.domain')}</Table.Th>
                <Table.Td>
                  {domain != null ? (
                    <Text size="sm">{domain}</Text>
                  ) : (
                    <Text
                      c="dimmed"
                      fs="italic"
                    >
                      nedefinit
                    </Text>
                  )}
                </Table.Td>
              </Table.Tr>

              <Table.Tr>
                <Table.Th>{t('labs.researchTeam')}</Table.Th>
                <Table.Td>
                  {researchTeam != null ? (
                    <Text size="sm">{researchTeam}</Text>
                  ) : (
                    <Text
                      c="dimmed"
                      fs="italic"
                    >
                      nedefinit
                    </Text>
                  )}
                </Table.Td>
              </Table.Tr>
            </Table.Tbody>
          </Table>
          <LabInfraList labId={laboratory.id} />
        </Stack>
      )}
      {isGathering && <CenterReport labId={laboratory.id} />}
    </Stack>
  );
}
